<template>
    <input ref="input" :disabled="readonly" />
</template>

<script lang="ts">
import { Component, Prop, Watch } from "vue-property-decorator";
import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import { mixins, Options, Vue } from "vue-class-component";
import WithModel from "@/mixins/withModel";
import { isValidDate } from '@/utils'

@Options({})
export default class OpDate extends mixins(WithModel) {

    @Prop({
        required: false,
        default: 'd/m/Y'
    }) format: string;
    @Prop() initialvalue: any;
    @Prop() minDate: any;
    @Prop() readonly: any;

    fp: any = null;
    mounted(){
        var initialDate = null;
        if(this.modelValue){
            initialDate = new Date(this.modelValue).toISOString();
        } else {
            if(this.initialvalue !== undefined){
                initialDate = this.initialvalue;
            } else {
                // this.emitModel(date);
            }
        }

        this.fp = flatpickr(this.$refs.input as HTMLInputElement, {
            defaultDate: initialDate,
            dateFormat: this.format,
            allowInput: true,
            parseDate: (datestr, format) => {

                let date = new Date(datestr);
                if(isValidDate(date) && date.toISOString() == datestr){
                    this.emitModel(date.toISOString());
                    return date;
                }

                if(datestr.indexOf("/") > -1 || datestr.indexOf("-") > -1 || datestr.indexOf(".") > -1){
                    datestr = datestr.replaceAll("/", "");
                    datestr = datestr.replaceAll("-", "");
                    datestr = datestr.replaceAll(".", "");
                }
                var giorno = datestr.substring(0, 2);
                var mese = datestr.substring(2, 4);
                var anno = datestr.substring(4, 8);

                let ris = new Date(parseInt(anno), parseInt(mese) - 1, parseInt(giorno));
                this.emitModel(ris.toISOString());
                return ris;
            },
            onChange: (val) => {
                this.emitModel(val[0].toISOString());
                // this.emitModel(this.validateDate(val[0]));
            },
            minDate: this.minDate
        });
    }

    beforeUnmount() {
        this.fp.destroy();
    }

    @Watch('value')
    onValueChange(next, prev){
        var data = null;
        if(next !== null){
            data = new Date(next).toISOString();
        }
        this.fp.setDate(data, false);
    }

    validateDate(inputDate: Date){
        if(this.isValidDate(inputDate)){
            let years = inputDate.getFullYear().toString();
            while(years.length < 4){
                years = "0" + years;
            } 
            let months = (inputDate.getMonth() + 1).toString();
            if(months.length < 2) months = "0" + months;
            let days = inputDate.getDate().toString();
            if(days.length < 2) days = "0" + days;
            return years +  "-" + months + "-" + days;
        }
    }
    
    isValidDate(d: any) {
        return d instanceof Date && !isNaN(d as any);
    }

}
</script>

<style scoped>

</style>